import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { deviceSlice, DeviceState, setIsDeviceFiltersSidebarOpenAction } from './device.slice';

export const deviceMiddleware: Middleware = (api) => (next) => (action) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const actionType = action?.type as string;
  const deviceStateBeforeAction = api.getState()?.[deviceSlice.name];

  if (deviceStateBeforeAction) {
    // NOTE: Middleware is executed BEFORE given action
    deviceMiddlewaresBeforeAction[actionType]?.(deviceStateBeforeAction);
  }

  const result = next(action);
  const deviceStateAfterAction = api.getState()?.[deviceSlice.name];

  if (deviceStateAfterAction) {
    // NOTE: Middleware is executed AFTER given action
    deviceMiddlewaresAfterAction[actionType]?.(deviceStateAfterAction);
  }

  return result;
};

type MiddlewareCallback = (state: DeviceState) => unknown;

const deviceMiddlewaresBeforeAction: Record<string, MiddlewareCallback> = {};

const deviceMiddlewaresAfterAction: Record<string, MiddlewareCallback> = {
  [setIsDeviceFiltersSidebarOpenAction.type]: (state: DeviceState) => {
    appStorage.device.setIsDeviceFiltersSidebarOpen(state.isDeviceFiltersSidebarOpen);
  },
};
